import React from "react";
import { Check } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";
import { t as nt } from "@/lib/negotiationLabels";

export function WsSection({ title, subtitle, right, children, testid }) {
  return (
    <section className="mb-6" data-testid={testid}>
      <div className="flex items-center justify-between gap-2 mb-2.5">
        <div>
          <h3 className="text-[13px] font-semibold uppercase tracking-[0.12em] text-foreground/90">{title}</h3>
          {subtitle && <p className="text-xs text-muted-foreground mt-0.5">{subtitle}</p>}
        </div>
        {right}
      </div>
      {children}
    </section>
  );
}

export function FieldStatusChip({ status }) {
  const meta = {
    athlynx: { label: nt("negotiationProfile.fieldStatus.athlynx"), cls: "bg-success/10 text-success border-success/30" },
    modified: { label: nt("negotiationProfile.fieldStatus.modified"), cls: "bg-info/10 text-info border-info/30" },
    missing: { label: nt("negotiationProfile.fieldStatus.missing"), cls: "bg-danger/10 text-danger border-danger/30" },
  }[status] || { label: status, cls: "bg-secondary text-muted-foreground border-border" };
  return <Badge variant="outline" className={cn("text-[9px] px-1.5 py-0 whitespace-nowrap", meta.cls)}>{meta.label}</Badge>;
}

export function TagGroup({ options, selected, max, onToggle, testidPrefix }) {
  return (
    <div className="flex flex-wrap gap-2" role="group">
      {options.map((o) => {
        const on = selected.includes(o.id);
        const disabled = !on && selected.length >= max;
        return (
          <button
            key={o.id}
            type="button"
            onClick={() => onToggle(o.id)}
            disabled={disabled}
            aria-pressed={on}
            data-testid={`${testidPrefix}-${o.id}`}
            className={cn(
              "inline-flex items-center gap-1.5 rounded-full border px-3 h-9 text-xs font-medium transition-colors",
              "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-athlynx/40",
              on
                ? "bg-athlynx text-white border-athlynx"
                : disabled
                  ? "border-border text-muted-foreground/40 cursor-not-allowed"
                  : "border-border text-foreground/80 hover:border-athlynx/40 hover:text-athlynx"
            )}
          >
            {on && <Check className="h-3 w-3" aria-hidden="true" />}
            {o.label}
          </button>
        );
      })}
    </div>
  );
}

export function CountBadge({ count, max }) {
  return (
    <span className={cn("text-xs font-semibold tabular-nums", count >= max ? "text-athlynx" : "text-muted-foreground")}
      aria-label={`${count} sur ${max} sélectionnés`}>
      {count} / {max}
    </span>
  );
}
